// Material UI imports
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';

// Local imports
import { FlowWelcomeProps } from '../../FlowWelcome';

let pos = 0;

function OpportunitiesPane(props) {
    const theme = useTheme();
    return (
        <Box 
            sx={{ display: 'flex', flexDirection: 'column', width: '522px', height: '100%', overflowY: 'auto', scrollTop: pos }}  
            onScroll={(e) => { 
                pos = e.target.scrollTop; 
            }}
            ref={(r) => { setTimeout(() => { if (r) r.scrollTop = pos; }, 100); }}
        >
            <Box sx={{ width: '100%', background: 'transparent', padding: '6px 24px', mb: 3, borderBottom: '1px solid rgba(59, 130, 246, 0.3)', boxShadow: 'none' }}>
                <Typography variant='body1' sx={{ fontSize: '12px', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.05em', color: '#334155' }}>
                    My Opportunities
                </Typography>
            </Box>
            <FlowWelcomeProps {...props} noHeader={true} />
        </Box>
    );
}

export default OpportunitiesPane;